import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParkingFacility = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m0 0h24v24h-24z",
		fill: "#001e72"
	}), /* @__PURE__ */ _jsx("path", {
		d: "m9 11.99h2.75c.95 0 1.69-.22 2.2-.65.52-.43.77-1.06.77-1.88s-.26-1.41-.77-1.83-1.25-.63-2.2-.63h-2.75v10",
		stroke: "#fff",
		strokeLinecap: "square",
		strokeWidth: 2
	})]
});
export default SvgParkingFacility;
